import { GET_OEMBED_FAILED, GET_OEMBED_REQUESTED } from "editor/actions/embed";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OEMBED_REQUESTED:
    case GET_OEMBED_FAILED:
      return { ...action.payload };
    default:
      return state;
  }
};
